
import {
    createApi,
    fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import ToastService from "../services/toastService";

const backendUrl = process.env.REACT_APP_API_URL;
const authMode = process.env.REACT_APP_AUTH_MODE;

// Prevent multiple logout operations
let isRedirectingToLogin = false;


// Base API configuration
const baseQuery = fetchBaseQuery({

    baseUrl: backendUrl,

    credentials: "include",

    prepareHeaders: (headers) => {

        headers.set("Content-Type", "application/json");

        // Bearer authentication
        if (authMode === "bearer") {

            const token = localStorage.getItem("token");

            if (token) {
                headers.set(
                    "Authorization",
                    `Bearer ${token}`
                );
            }
        }

        return headers;
    },
});


// Common 401 error handling
const baseQueryWith401Handling = async (
    args,
    api,
    extraOptions
) => {

    const result = await baseQuery(
        args,
        api,
        extraOptions
    );

    // Check unauthorized response
    if (result?.error?.status === 401) {

        console.warn("401 Unauthorized detected");

        // Prevent multiple redirects
        if (!isRedirectingToLogin) {

            isRedirectingToLogin = true;

            try {
                ToastService.error(
                    result?.error?.data.message || "Unauthorized Request."
                );
                // Preserve theme
                const theme = localStorage.getItem("theme");

                // Clear user session
                localStorage.clear();

                // Restore theme
                if (theme !== null) {
                    localStorage.setItem("theme", theme);
                }

                // Clear RTK Query cache
                api.dispatch(
                    api.util.resetApiState()
                );

                // Redirect to login
                window.location.replace("/");

            } catch (error) {

                console.error(
                    "Unauthorized handling failed:",
                    error
                );

                window.location.replace("/");
            }
        }
    }

    return result;
};


// Common API service
export const apiService = createApi({

    reducerPath: "apiService",

    baseQuery: baseQueryWith401Handling,

    tagTypes: [
        "FlexzaiDialerAdmin"
    ],

    endpoints: (builder) => ({

        apiRequest: builder.mutation({

            query: ({
                url,
                method = "GET",
                data
            }) => ({

                url,

                method,

                body: data,

            }),

            // Cache invalidation
            invalidatesTags: (result, error, arg) => {

                if (!arg || !arg.method) {
                    return [];
                }

                const method = arg.method.toUpperCase();

                if (
                    ["POST", "PUT", "PATCH", "DELETE"].includes(method)
                ) {
                    return ["FlexzaiDialerAdmin"];
                }

                return [];
            },

            // Cache provision
            providesTags: (result, error, arg) => {

                if (!arg || !arg.method) {
                    return [];
                }

                const method = arg.method.toUpperCase();

                if (method === "GET") {
                    return ["FlexzaiDialerAdmin"];
                }

                return [];
            },

        }),

    }),

});


// Export hooks
export const {
    useApiRequestMutation
} = apiService;

